import React from "react";
import { useNavigate } from "react-router-dom";
import SignUpPrompt from "@/components/Motivation/SignUpPrompt";

interface SignupToContinueProps {}

const SignupToContinue: React.FC<SignupToContinueProps> = () => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/signup");
  };

  return <SignUpPrompt buttonAction={handleSignUp} signupToContinue={true} />;
};

export default SignupToContinue;
